<template>
    <div class="group-travel">
        <h1 v-text="translations.header"></h1>
        <h2 v-text="translations.offerHeader"></h2>
        <p v-html="translations.offerText"></p>
        <h2 v-text="translations.formHelpHeader"></h2>
        <div class="group-travel__illustrations">
            <div class="group-travel__illustrations__item group-travel__illustrations__item--adults">
                <span>5 voksne (eller flere)</span>
                <img src="../../../assets/img/icons/group-travel-adults.svg">
            </div>
            <div class="group-travel__illustrations__item group-travel__illustrations__item--children">
                <span>5 børn (eller flere)</span>
                <img src="../../../assets/img/icons/group-travel-children.svg">
            </div>
            <div class="group-travel__illustrations__item group-travel__illustrations__item--houses">
                <span>2 boligenheder (eller flere)</span>
                <img src="../../../assets/img/icons/group-travel-houses.svg">
            </div>
        </div>
        <div class="group-travel-form" v-if="success">
            <msg-block type="success">
                <span v-text="translations.successMsg"></span>
            </msg-block>
        </div>
        <div class="group-travel-form" v-if="!success">
            <h1 v-text="translations.formHeader"></h1>
            <div class="booking-block">
                <search-destination v-model="selectedDestinationAirport" :show-selector="showSelector"
                    :open-modal="openModal" :empty-on-select="true" @hide="showSelector = null"
                    @show="showSelector = 'destination-selector'" :disabled="destinations.length >= 2"></search-destination>
                <div class="group-travel__destinations">
                    <h3 v-text="translations.input.destinations"></h3>
                    <ul>
                        <li v-for="destination in destinations" @click.stop="removeDestination(destination)">{{
                            destination.name }}
                            <button>
                                <img src="../../../assets/img/icons/icon-delete.svg" alt="Fjern">
                            </button>
                        </li>
                    </ul>
                </div>
                <msg-block type="error" v-if="errors.destinations">
                    <span v-if="errors.destinations"><b v-text="errors.destinations[0]"></b></span>
                </msg-block>
            </div>
            <div class="booking-block">
                <div class="group-travel__flex">
                    <div class="group-travel__flex__item">
                        <date-picker :name="translations.input.travelFromDate" :default-date="groupData.fromdate"
                            :is-ready="true" :start-from="startDate.format('DD-MM-YYYY')" :end-at="groupData.todate"
                            @pickdate="(date) => groupData.fromdate = date" format="DD-MM-YYYY"></date-picker>
                        <msg-block type="error" v-if="errors.fromdate">
                            <span v-if="errors.fromdate"><b v-text="errors.fromdate[0]"></b></span>
                        </msg-block>
                    </div>
                    <div class="group-travel__flex__item">
                        <date-picker :name="translations.input.travelToDate" :default-date="groupData.todate"
                            :is-ready="true" @pickdate="(date) => groupData.todate = date"
                            :start-from="groupData.fromdate || startDate.format('DD-MM-YYYY')"
                            format="DD-MM-YYYY"></date-picker>
                        <msg-block type="error" v-if="errors.todate">
                            <span v-if="errors.todate"><b v-text="errors.todate[0]"></b></span>
                        </msg-block>
                    </div>
                </div>
                <div>
                    <h3 v-text="translations.input.travelTime"></h3>
                    <div class="label-input booking-field">
                        <select v-model="groupData.duration">
                            <option :value="0" v-text="translations.input.selectTravelTime"></option>
                            <option value="exact" v-text="translations.input.selectedTravelTimeDates"></option>
                            <option v-for="n in 42" :value="n">{{ n }} {{ (n < 1) ? translations.input.day :
                                translations.input.days }}</option>
                            <option value="6weeksplus" v-text="translations.input.moreThen6Weeks"></option>
                        </select>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                            <path
                                d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                style="fill: rgb(140, 140, 130);"></path>
                        </svg>
                    </div>
                    <msg-block type="error" v-if="errors.duration">
                        <span v-if="errors.duration"><b v-text="errors.duration[0]"></b></span>
                    </msg-block>
                </div>
            </div>
            <div class="group-travel__budget">
                <h3 v-text="translations.input.price"></h3>
                <p v-text="translations.input.budgetHelp"></p>
                <p><span v-text="translations.input.budgetInfo"></span></p>
                <vue-slider v-model="groupData.budget" :min="0" :max="250000" :tooltip="false" :interval="500"
                    class="group-travel-slider"></vue-slider>
                <p>{{ translations.input.choosenBudget }} <span v-if="groupData.budget"><span
                            v-price="groupData.budget"></span>,- DKK</span> <span v-if="!groupData.budget"
                        v-text="translations.input.noBudget"></span></p>
                <msg-block type="error" v-if="errors.budget">
                    <span v-if="errors.budget"><b v-text="errors.budget[0]"></b></span>
                </msg-block>
            </div>
            <div class="booking-block booking-block--no-margin">
                <div class="group-travel__hotel-stars">
                    <h3 v-text="translations.input.hotelCategories"></h3>
                    <div class="group-travel__checkboxes">
                        <div class="group-travel__checkboxes__item">
                            <checkbox :name="'2 ' + translations.input.stars" :value="groupData.kategori.indexOf(2) > -1"
                                @checked="(checked) => setCategories(2, checked)"></checkbox>
                        </div>
                        <div class="group-travel__checkboxes__item">
                            <checkbox :name="'3 ' + translations.input.stars" :value="groupData.kategori.indexOf(3) > -1"
                                @checked="(checked) => setCategories(3, checked)"></checkbox>
                        </div>
                        <div class="group-travel__checkboxes__item">
                            <checkbox :name="'4 ' + translations.input.stars" :value="groupData.kategori.indexOf(4) > -1"
                                @checked="(checked) => setCategories(4, checked)"></checkbox>
                        </div>
                        <div class="group-travel__checkboxes__item">
                            <checkbox :name="'5 ' + translations.input.stars" :value="groupData.kategori.indexOf(5) > -1"
                                @checked="(checked) => setCategories(5, checked)"></checkbox>
                        </div>
                    </div>
                    <msg-block type="error" v-if="errors.kategori">
                        <span v-if="errors.kategori"><b v-text="errors.kategori[0]"></b></span>
                    </msg-block>
                </div>
            </div>
            <div class="booking-block booking-block--no-margin">
                <h3 v-text="translations.input.roomType"></h3>
                <div v-for="(roomType, roomTypeKey) in translations.input.roomTypes" class="group-travel__room-checkbox">
                    <checkbox :name="roomType.name" :value="(selectedRoomTypes[roomType.value]) ? true : false"
                        @checked="(checked) => setRoomType(roomType, checked)"></checkbox>
                    <button @click="showRoomHelpTxt = roomTypeKey" class="btn btn--help">?</button>
                    <div class="label-input booking-field" v-if="(selectedRoomTypes[roomType.value]) ? true : false">
                        <select :value="selectedRoomTypes[roomType.value].rooms.length"
                            @input="$event => setRoomTypeCount(roomType.value, $event.target.value)">
                            <option :value="0" v-text="translations.input.roomCount"></option>
                            <option v-for="n in 10" :value="n">{{ n }}</option>
                        </select>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                            <path
                                d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                style="fill: rgb(140, 140, 130);"></path>
                        </svg>
                    </div>
                </div>
                <msg-block type="info" v-if="showRoomHelpTxt !== null">
                    <span><strong v-text="translations.input.roomTypes[showRoomHelpTxt].name"></strong>: {{
                        translations.input.roomTypes[showRoomHelpTxt].helpTxt }}</span>
                    <span v-html="translations.input.roomWarning"></span>
                </msg-block>
                <msg-block type="error" v-if="errors.roomtype || errors.roomcount">
                    <span v-if="errors.roomtype"><b v-text="errors.roomtype[0]"></b></span>
                    <span v-if="errors.roomcount"><b v-text="errors.roomcount[0]"></b></span>
                </msg-block>
            </div>
            <div class="booking-block booking-block--no-margin">
                <h3 v-text="translations.input.roomType"></h3>
                <div v-for="(selectedRoomType, selectedRoomTypeKey) in selectedRoomTypes"
                    :key="'roomtypekey_' + selectedRoomTypeKey">
                    <div v-for="(room, key) in selectedRoomType.rooms" :key="'room_' + key">
                        <roomdata :roomTypeName="`${selectedRoomType.name} ${key + 1}`" :value="room"
                            @input="$value => setRoomData(selectedRoomTypeKey, key, $value)"></roomdata>
                    </div>
                </div>
                <msg-block type="error" v-if="errors.childage">
                    <span v-if="errors.childage"><b v-text="errors.childage[0]"></b></span>
                </msg-block>
                <msg-block type="error" v-if="errors.adults">
                    <span v-if="errors.adults"><b v-text="errors.adults[0]"></b></span>
                </msg-block>
            </div>
            <div class="booking-block booking-block--no-margin group-travel__food">
                <h3 v-text="translations.input.pensionTxt"></h3>
                <div class="label-input booking-field">
                    <select v-model="groupData.pension">
                        <option v-for="(txt, value) in translations.input.pension" :value="value" v-text="txt"></option>
                    </select>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                        <path
                            d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                            style="fill: rgb(140, 140, 130);"></path>
                    </svg>
                </div>
            </div>
            <div class="booking-block booking-block--no-margin group-travel__comments">
                <input-field :name="translations.input.comments" input-type="textarea" :value="groupData.comments"
                    @input="(val) => groupData.comments = val"></input-field>
            </div>
            <div class="booking-block booking-block--no-margin">
                <div class="booking-block__content">
                    <div class="input-fields">
                        <h3 v-text="translations.input.contactperson_header"></h3>
                        <div class="input-fields__content">
                            <div class="label-input booking-field">
                                <select v-model="groupData.title">
                                    <option v-for="(txt, value) in translations.input.sexOptions" :value="value"
                                        v-text="txt"></option>
                                </select>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                                    <path
                                        d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                        style="fill: rgb(140, 140, 130);"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="input-fields">
                        <div class="input-fields__content">
                            <input-field :name="translations.input.firstName" :value="groupData.firstname"
                                @input="(inp) => this.groupData.firstname = inp"
                                :icon-type="(!groupData.firstname) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--firstname"></input-field>
                            <input-field :name="translations.input.lastName" :value="groupData.lastname"
                                @input="(inp) => this.groupData.lastname = inp"
                                :icon-type="(!groupData.lastname) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--lastname"></input-field>
                        </div>
                        <msg-block type="error" v-if="errors.firstname || errors.lastname">
                            <span v-if="errors.firstname"><b v-text="errors.firstname[0]"></b></span>
                            <span v-if="errors.lastname"><b v-text="errors.lastname[0]"></b></span>
                        </msg-block>
                    </div>
                    <div class="input-fields">
                        <div class="input-fields__content">
                            <input-field :name="translations.input.address" :value="groupData.address"
                                @input="(inp) => this.groupData.address = inp"
                                :icon-type="(!groupData.address) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--address"></input-field>
                        </div>
                        <msg-block type="error" v-if="errors.address">
                            <span v-if="errors.address"><b v-text="errors.address[0]"></b></span>
                        </msg-block>
                    </div>
                    <div class="input-fields">
                        <div class="input-fields__content">
                            <input-field :name="translations.input.postal" input-type="tel" mask="9999"
                                :value="groupData.zipcode" @input="(inp) => this.groupData.zipcode = inp.substr(0, 4)"
                                :icon-type="(!groupData.zipcode) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--zipcode"></input-field>
                            <input-field :name="translations.input.town" :value="groupData.city"
                                @input="(inp) => this.groupData.city = inp"
                                :icon-type="(!groupData.city) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--city"></input-field>
                        </div>
                        <msg-block type="error" v-if="errors.zipcode || errors.city">
                            <span v-if="errors.zipcode"><b v-text="errors.zipcode[0]"></b></span>
                            <span v-if="errors.city"><b v-text="errors.city[0]"></b></span>
                        </msg-block>
                    </div>
                    <div class="input-fields">
                        <div class="input-fields__content">
                            <input-field :name="translations.input.phone" input-type="tel" :value="groupData.phone"
                                @input="(inp) => this.groupData.phone = inp"
                                :icon-type="(!groupData.phone) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--phone"></input-field>
                        </div>
                        <msg-block type="error" v-if="errors.phone">
                            <span v-if="errors.phone"><b v-text="errors.phone[0]"></b></span>
                        </msg-block>
                    </div>
                    <div class="input-fields">
                        <div class="input-fields__content">
                            <input-field :name="translations.input.email" input-type="email" :value="groupData.email"
                                @input="(inp) => this.groupData.email = inp"
                                :icon-type="(!groupData.email) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--mail"></input-field>
                            <input-field :name="translations.input.email_confirm" input-type="email"
                                :value="groupData.emailconfirm" @input="(inp) => this.groupData.emailconfirm = inp"
                                :icon-type="(groupData.emailconfirm !== groupData.email) ? '' : this.checkmarkIcon"
                                class="booking-field booking-field--mailconfirm"></input-field>
                        </div>
                        <msg-block type="error" v-if="errors.email || errors.email_confirm">
                            <span v-if="errors.email"><b v-text="errors.email[0]"></b></span>
                            <span v-if="errors.email_confirm"><b v-text="errors.email_confirm[0]"></b></span>
                        </msg-block>
                    </div>
                </div>
            </div>
            <div>
                <checkbox :name="translations.input.newsletter" :value="groupData['contact-newsletter']"
                    @checked="(checked) => groupData['contact-newsletter'] = checked"></checkbox>
            </div>
            <button v-text="translations.input.submit" class="btn btn--submit" @click.stop="submit" :disabled="loading"
                :class="{ 'item-loading': loading }"></button>
            <msg-block type="error" v-if="hasErrors">
                <span v-if="!errors.submiterror"><b v-text="translations.ERRORS.hasErrors"></b></span>
                <span v-if="errors.submiterror"><b v-text="errors.submiterror[0]"></b></span>
            </msg-block>
        </div>
        <div class="group-travel__recpapcha-text">
            <p>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
        </div>
    </div>
</template>

<script>
import Checkbox from './checkbox.vue'
import VueSlider from 'vue-slider-component';
import InputField from './input-field.vue';
import MsgBlock from './msg-block.vue';
import DatePicker from './datepicker/datepicker.vue';
import SearchDestination from './search-destination.vue';
import Selector from './selector.vue';
import _ from 'underscore';
import SkovApi from './../skovapi.js';
import Roomdata from './group-travel/room-data.vue';
import Validate from 'validate.js';
import Moment from 'moment';

const DefaultRoomData = {
    adults: [],
    children: [],
    valid: false
}

export default {
    data() {
        return {
            checkmarkIcon: 'checkmark',
            showRoomHelpTxt: null,
            errors: {},
            selectedDestinationAirport: null,
            showSelector: '',
            openModal: null,
            destinations: [],
            selectedRoomTypes: {},
            loading: false,
            success: false,
            groupData: {
                traveltype: 'Gruppenreise',
                departure: 'Hamburg',
                preferredlanguage: 'Englisch',
                duration: 0,
                fromdate: '',
                todate: '',
                budget: 0,
                kategori: [],
                roomtype: [],
                pension: 'Ohne Verpflegung',
                comments: '',
                title: 'Frau',
                firstname: '',
                lastname: '',
                address: '',
                zipcode: '',
                city: '',
                email: '',
                emailconfirm: '',
                phone: '',
                'contact-newsletter': false,
                encoded_destination_list: ''
            },
            translations: APP_CONFIG.TRANSLATION.GROUP_TRAVELS
        }
    },
    watch: {
        showSelector() {
            setTimeout(() => {
                this.openModal = this.showSelector;
            }, 250);
        },
        selectedDestinationAirport() {
            if (this.selectedDestinationAirport) {
                let exists = this.destinations.filter((destination) => destination.id === this.selectedDestinationAirport.id);
                if (exists.length <= 0) {
                    this.destinations.push(Object.assign({}, this.selectedDestinationAirport));
                }

                this.selectedDestinationAirport = null;
                this.showSelector = '';
            }
        },
        'groupData.zipcode'() {
            if (this.groupData.zipcode && this.groupData.zipcode.length === 4) {
                SkovApi.getTownByZip(this.groupData.zipcode).then((town) => {
                    if (town) {
                        this.groupData.city = town;
                    }
                });
            }
        }
    },
    methods: {
        submit() {
            this.$emit('submit');
            let errors = this.getFormErrors();
            if (errors) {
                this.errors = errors;
                return;
            }

            this.errors = {};
            if (this.loading)
                return;

            if(!grecaptcha) {
                console.error('reCAPCHA not loaded!');
                return;
            }

            this.loading = true;
            grecaptcha.ready(() => {
                grecaptcha.execute(APP_CONFIG.RECAPCHA_SITE_KEY, {action: 'submit'}).then((token) => {
                    let form = new FormData();
                    for (let key in this.computedGroupData) {
                        if (typeof this.computedGroupData[key] === 'object') {
                            for (let y in this.computedGroupData[key]) {
                                let arrayKey = key + '[' + y + ']';
                                form.append(arrayKey, this.computedGroupData[key][y]);
                            }
                        } else {
                            form.append(key, this.computedGroupData[key]);
                        }
                    }

                    form.append('g-recaptcha-response', token);

                    SkovApi.submitGroupTravel(form, !APP_CONFIG.IS_PRODUCTION).then((res) => {
                        this.success = true;
                        this.loading = false;
                    }).catch((err) => {
                        console.error(err);
                        this.loading = false;
                        this.$set(this.errors, 'submiterror', [this.translations.ERRORS.submiterror]);
                    })
                });
            });
        },
        setLang(lang) {
            this.groupData.preferredlanguage = '';
            this.$nextTick(() => {
                this.groupData.preferredlanguage = lang;
            })
        },
        setCategories(category, checked) {
            if (checked) {
                this.groupData.kategori.push(category);
                this.$nextTick(() => {
                    if (this.groupData.kategori.length > 2) {
                        let idx = this.groupData.kategori.indexOf(category);
                        alert(this.translations.ERRORS.kategoriLimit);
                        if (idx > -1) {
                            this.groupData.kategori.splice(idx, 1);
                        }
                    }
                })
            } else {
                let idx = this.groupData.kategori.indexOf(category);
                if (idx > -1) {
                    this.groupData.kategori.splice(idx, 1);
                }
            }
        },
        setRoomType(roomtype, checked) {
            if (checked) {
                this.$set(this.selectedRoomTypes, roomtype.value, {
                    name: roomtype.name,
                    rooms: []
                });
            } else {
                this.$delete(this.selectedRoomTypes, roomtype.value);
            }
        },
        setRoomTypeCount(roomTypeVal, count) {
            console.log(count);
            let obj = Object.assign({}, this.selectedRoomTypes[roomTypeVal]);
            if (obj.rooms.length > count) {
                obj.rooms.splice(count);
            } else {
                do {
                    obj.rooms.push(Object.assign({}, DefaultRoomData));
                } while (obj.rooms.length < count)
            }

            this.$set(this.selectedRoomTypes, roomTypeVal, obj);
        },
        setRoomData(roomType, roomKey, data) {
            const selectedRoomType = Object.assign({}, this.selectedRoomTypes[roomType]);
            const selectedRoomTypeRoooms = Object.assign([], selectedRoomType.rooms);
            if (selectedRoomTypeRoooms[roomKey]) {
                selectedRoomTypeRoooms[roomKey] = Object.assign({}, selectedRoomTypeRoooms[roomKey], data);
                this.$set(this.selectedRoomTypes, roomType, Object.assign({}, selectedRoomType, { rooms: selectedRoomTypeRoooms }));
            }
        },
        removeDestination(destination) {
            let idx = this.destinations.indexOf(destination);
            if (idx > -1) {
                this.destinations.splice(idx, 1);
            }
        },
        getFormErrors() {
            let errors = {};
            let validationObject = {
                todate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.todate
                    }
                },
                fromdate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.fromdate
                    }
                },
                roomtype: {
                    length: {
                        minimum: 1,
                        message: this.translations.ERRORS.roomtype
                    }
                },
                kategori: {
                    length: {
                        minimum: 1,
                        message: this.translations.ERRORS.kategori
                    }
                },
                budget: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.budget
                    },
                    numericality: {
                        greaterThan: 1,
                        message: this.translations.ERRORS.budget
                    }
                },
                duration: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.duration
                    }
                },
                firstname: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.firstName
                    }
                },
                lastname: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.lastName
                    }
                },
                address: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.address
                    }
                },
                zipcode: {
                    numericality: {
                        message: this.translations.ERRORS.zipCode
                    },
                    length: {
                        is: 4,
                        message: this.translations.ERRORS.zipCode_tooshort
                    }
                },
                city: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.city
                    }
                },
                email: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email
                    },
                    email: {
                        message: this.translations.ERRORS.email_not_valid
                    }
                },
                emailconfirm: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email
                    },
                    email: {
                        message: this.translations.ERRORS.email_not_valid
                    }
                },
                phone: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.phone
                    }
                }
            };

            errors = Object.assign(errors, Validate(this.computedGroupData, validationObject, {
                fullMessages: false
            }));

            let totalNumberOfAdults = 0;
            for (let i in this.computedGroupData) {
                if (i.match(/_child_/) && !this.computedGroupData[i]) {
                    errors.childage = [this.translations.ERRORS.childage];
                }

                if (i.match(/_desadults_/)) {
                    totalNumberOfAdults += this.computedGroupData[i];
                }

                if (i.match(/_count$/) && !this.computedGroupData[i]) {
                    errors.roomcount = [this.translations.ERRORS.roomcount];
                }
            }

            if (Object.values(this.selectedRoomTypes).filter(
                ({ rooms }) => rooms.filter(({ valid }) => !valid).length
            ).length) {
                errors.rooms = [];
            }

            if (totalNumberOfAdults <= 0) {
                errors.adults = [this.translations.ERRORS.adults];
            }

            if (this.destinations.length <= 0) {
                errors.destinations = [this.translations.ERRORS.destinations];
            }

            if (this.groupData.email != this.groupData.emailconfirm) {
                errors.email_confirm = [this.translations.ERRORS.email_not_equal];
            }

            if (Moment(this.groupData.fromdate, 'DD-MM-YYYY').isAfter(Moment(this.groupData.todate, 'DD-MM-YYYY'))) {
                errors.fromdate = [this.translations.ERRORS.date_error];
            }

            return (!_.isEmpty(errors)) ? errors : null;
        }
    },
    computed: {
        computedGroupData() {
            let groupData = Object.assign({}, this.groupData);
            groupData.roomtype = _.keys(this.selectedRoomTypes);

            let adults = 0;
            let children = 0;

            for (let designation in this.selectedRoomTypes) {
                let countStr = designation + '_count';
                groupData[countStr] = this.selectedRoomTypes[designation].rooms.length;

                for (let roomIdx in this.selectedRoomTypes[designation].rooms) {
                    const currentRoom = this.selectedRoomTypes[designation].rooms[roomIdx];
                    const currentRoomKey = parseInt(roomIdx) + 1;

                    const adultParamterName = designation + '_desadults_' + currentRoomKey;
                    const adultCountValue = currentRoom.adults.length;

                    if (adultCountValue) {
                        adults += parseInt(adultCountValue);
                        groupData[adultParamterName] = adultCountValue;
                        for (let adultIdx in currentRoom.adults) {
                            const adult = currentRoom.adults[adultIdx];
                            const adultKey = parseInt(adultIdx) + 1;
                            const adultParameterGender = `${adultParamterName}_gender_${adultKey}`;
                            const adultParameterFirstname = `${adultParamterName}_firstname_${adultKey}`;
                            const adultParameterLastname = `${adultParamterName}_lastname_${adultKey}`;
                            const adultParameterBirthdate = `${adultParamterName}_birthdate_${adultKey}`;

                            groupData[adultParameterGender] = adult.gender;
                            groupData[adultParameterFirstname] = adult.firstname;
                            groupData[adultParameterLastname] = adult.lastname;
                            groupData[adultParameterBirthdate] = adult.birthdate;
                        }
                    }

                    const childParamterName = designation + '_deschilds_' + currentRoomKey;
                    const childCountValue = currentRoom.children.length;

                    if (childCountValue) {
                        children += parseInt(childCountValue);
                        groupData[childParamterName] = childCountValue;
                        for (let childIdx in currentRoom.children) {
                            const child = currentRoom.children[childIdx];
                            const childKey = parseInt(childIdx) + 1;
                            const childParameterGender = `${childParamterName}_gender_${childKey}`;
                            const childParameterFirstname = `${childParamterName}_firstname_${childKey}`;
                            const childParameterLastname = `${childParamterName}_lastname_${childKey}`;
                            const childParameterBirthdate = `${childParamterName}_birthdate_${childKey}`;

                            groupData[childParameterGender] = child.gender;
                            groupData[childParameterFirstname] = child.firstname;
                            groupData[childParameterLastname] = child.lastname;
                            groupData[childParameterBirthdate] = child.birthdate;
                        }
                    }
                }
            }

            groupData = Object.assign({}, groupData, { adults, children });
            groupData.encoded_destination_list = JSON.stringify(this.computedDestinationList);
            return groupData;
        },
        computedDestinationList() {
            return this.destinations.map((destination) => {
                if (destination.type === 'hotel') {
                    return destination.name + " (Giata-ID: " + destination.id + ")";
                } else {
                    return destination.name;
                }
            });
        },
        hasErrors() {
            return (!_.isEmpty(this.errors)) ? true : false;
        },
        startDate() {
            return Moment();
        }
    },
    components: {
        Checkbox,
        VueSlider,
        InputField,
        MsgBlock,
        DatePicker,
        SearchDestination,
        Selector,
        Roomdata
    }
}
</script>
